import React from "react";
import Sidebar from '../components/Sidebar';
import Header from "../components/Header";

const Unauthorized = () => {
  return (
    <div className="d-flex vh-100 ">
     {/* FIX: make the Sidebar a real fixed-size flex item */}
      <div style={{ flex: '0 0 250px', minWidth: 250, maxWidth: 250, overflowY: 'auto' }}>
        <Sidebar />
        
      </div>
       <div style={{ flex: '1 1 auto', minWidth: 0, overflow: 'hidden', overflowY: 'auto' }}>
        {/* Header flush at top */}
        <Header />
      <div className="text-center">
        <h2 className="text-danger">Access Denied</h2>
        <p>You don't have permission to view this page.</p>
      </div>
    </div>
    </div>
  );
};

export default Unauthorized;
